<template lang="pug">

div
    .ui.secondary.menu

        router-link.item(:to='{ name: "companies" }' exact) Übersicht Unternehmen
        router-link.item(:to='{ name: "companies/update" }' v-if="isUpdateVisible") Unternehmen bearbeiten
        router-link.item(:to='{ name: "companies/create" }') Unternehmen anlegen

    .ui.divider

</template>

<script>

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {
            isUpdateVisible() {
                return this.$route.name === 'companies/update'
            }
        }

    }

</script>

